"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationStatus = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../icons");
var styles_1 = require("../../../styles");
var StyledResultItem = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 1.7;\n  color: ", ";\n  display: flex;\n  align-items: center;\n"], ["\n  font-size: 12px;\n  line-height: 1.7;\n  color: ", ";\n  display: flex;\n  align-items: center;\n"])), styles_1.COLOR.font.base);
var StyledIcon = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 0.2em;\n  svg {\n    fill: ", ";\n    display: block;\n    width: 12px;\n    height: 12px;\n  }\n"], ["\n  margin-left: 0.2em;\n  svg {\n    fill: ", ";\n    display: block;\n    width: 12px;\n    height: 12px;\n  }\n"])), function (_a) {
    var valid = _a.valid;
    return (valid && '#4caf50') || styles_1.COLOR.font.disabledIcon;
});
var ValidationStatusItem = function (_a) {
    var valid = _a.valid, label = _a.label;
    var icon = valid ? icons_1.CHECK_ICON : icons_1.MINUS_ICON;
    return (react_1.default.createElement(StyledResultItem, null,
        react_1.default.createElement("div", null, label),
        react_1.default.createElement(StyledIcon, { valid: valid, role: "img", "aria-label": "", dangerouslySetInnerHTML: { __html: icon } })));
};
var StyledList = styled_1.default.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  list-style: none;\n  display: flex;\n  align-items: center;\n  > li + li {\n    margin-left: 8px;\n  }\n"], ["\n  list-style: none;\n  display: flex;\n  align-items: center;\n  > li + li {\n    margin-left: 8px;\n  }\n"])));
var ValidationStatus = function (_a) {
    var maxLength = _a.maxLength, minLength = _a.minLength, length = _a.length, upperCase = _a.upperCase, lowerCase = _a.lowerCase, number = _a.number, symbol = _a.symbol, className = _a.className;
    return (react_1.default.createElement(StyledList, { className: className },
        length && (react_1.default.createElement("li", null,
            react_1.default.createElement(ValidationStatusItem, { label: lengthLabel({ minLength: minLength, maxLength: maxLength }), valid: length.valid }))),
        upperCase && (react_1.default.createElement("li", null,
            react_1.default.createElement(ValidationStatusItem, { label: "\u5927\u6587\u5B57", valid: upperCase.valid }))),
        lowerCase && (react_1.default.createElement("li", null,
            react_1.default.createElement(ValidationStatusItem, { label: "\u5C0F\u6587\u5B57", valid: lowerCase.valid }))),
        number && (react_1.default.createElement("li", null,
            react_1.default.createElement(ValidationStatusItem, { label: "\u6570\u5B57", valid: number.valid }))),
        symbol && (react_1.default.createElement("li", null,
            react_1.default.createElement(ValidationStatusItem, { label: "\u8A18\u53F7", valid: symbol.valid })))));
};
exports.ValidationStatus = ValidationStatus;
var lengthLabel = function (_a) {
    var _b = _a.minLength, minLength = _b === void 0 ? 1 : _b, _c = _a.maxLength, maxLength = _c === void 0 ? 70 : _c;
    if (minLength === maxLength)
        return minLength + "\u6587\u5B57";
    return minLength + "\u301C" + maxLength + "\u6587\u5B57";
};
var templateObject_1, templateObject_2, templateObject_3;
